<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('pollQuestions.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_poll_question')"
                :title="$addLabel('pollQuestion')"
                @click="openPollModal()"
            />
        </app-page-top-section>

        <app-table
            id="poll-question-table"
            :options="options"
            @action="triggerActions"
        />

        <app-poll-question-modal
            v-if="isPollQuestionModalActive"
            v-model="isPollQuestionModalActive"
            :selected-url="selectedUrl"
            />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('poll-question-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import PollQuestionMixin from "../../../Mixins/Pms/PollQuestionMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "pollQuestions",
    mixins: [PollQuestionMixin],
    data() {
        return {
            pollQuestion: '',
            pollQuestionsId: '',
            pollQuestions: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            isPollQuestionModalActive: false,
            confirmationModalActive: false,
        }
    },
    watch: {
        isPollQuestionModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openPollModal() {
            this.selectedUrl = '';
            this.isPollQuestionModalActive = true;
        },
        triggerActions(row, action, active) {
            this.pollQuestionsId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isPollQuestionModalActive = true;
            }
            if (action.name === 'view_details') {
                this.selectedUrl = window.location = urlGenerator(`${action.url}/${row.id}`);
            }
            else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
